import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo */}
        <div className="footer-logo">
          <a href="/" aria-label="Trademark home">
            <img
              className="brand-img"
              src={"/light-blue-logo.png"}
              alt="Trademark Radar logo"
            />
          </a>
          <span className='text-dark'>Trademark Radar</span></div>

        {/* Navigation Links */}
        <nav className="footer-nav">
          <a href="#why">Γιατί δημιουργήθηκε;</a>
          <a href="#how">Πώς λειτουργεί;</a>
          <a href="#who">Σε ποιους απευθύνεται;</a>
          <a href="#pricing">Τιμές</a>
          <a href="#contact">Επικοινωνία</a>
        </nav>

        {/* Social Media Icons */}
        <div className="footer-social">
          {/* Facebook 
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
            </svg>
          </a>

          {/* Instagram 
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
            </svg>
          </a>*/}

          {/* Phone */}
          <a href="tel:+302103387344" aria-label="Phone">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z" />
            </svg>
          </a>
        </div>

        {/* Business Information */}
        <div className="footer-business-info">
          <div className="footer-info-grid">
            <div className="footer-info-item">
              <span className="footer-info-label">Επωνυμία:</span>
              <span className="footer-info-value">TRADEMARK RADAR L.L.C.</span>
            </div>
            <div className="footer-info-item">
              <span className="footer-info-label">Αριθμός ΓΕΜΗ:</span>
              <span className="footer-info-value">005624201000</span>
            </div>
            <div className="footer-info-item">
              <span className="footer-info-label">EUID:</span>
              <span className="footer-info-value">ELGEMI.005624201000</span>
            </div>
            <div className="footer-info-item">
              <span className="footer-info-label">ΑΦΜ:</span>
              <span className="footer-info-value">999367977</span>
            </div>
            <div className="footer-info-item">
              <span className="footer-info-label">Νομική Μορφή:</span>
              <span className="footer-info-value">ΕΠΕ</span>
            </div>
            
            <div className="footer-info-item">
              <span className="footer-info-label">Διεύθυνση:</span>
              <span className="footer-info-value">ΙΠΠΟΚΡΑΤΟΥΣ 7, ΑΘΗΝΑΙΩΝ / ΚΕΝΤΡΙΚΟΥ ΤΟΜΕΑ ΑΘΗΝΩΝ</span>
            </div>
            <div className="footer-info-item">
              <span className="footer-info-label">Τηλέφωνα:</span>
              <span className="footer-info-value">
                <a href="tel:+302103387344">210 338 7344</a>
                {' | '}
                <a href="tel:+302120002455">212 000 2455</a>
              </span>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-copyright">
          © {currentYear} Trademark Radar
        </div>
      </div >
    </footer  >
  );
};

export default Footer;
